<template>
  <div class="win-freeBet__wrapper">
    <div class="win-freeBet__title">
      {{ $t('freebet.popup.award') }} <br />
      {{ $t('freebet.popup.select_for_play') }}
    </div>
    <div class="win-freeBet__parameters">{{ getBetCount }}<br />{{ getBet }}</div>
    <div class="win-freeBet__btn" @click="openFreeBetsPopup">{{ $t('freebet.popup.select') }}</div>
    <div class="win-freeBet__close" @click="closePopup">
      <div class="wrapper_btn_close"></div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { IFreeBetSpin } from '@/store/defaultObjects';
import { Utils } from '@/utils/Utils';
import { ACTION } from '@/store/ACTION';

export default Vue.extend({
  name: 'WinFreeBetMessage',
  computed: {
    ...mapGetters(['getActiveFreeBetSpins', 'getFreeBetWin', 'getFreeBetCurrencyCode']),
    getFreeBet(): IFreeBetSpin {
      return this.getActiveFreeBetSpins.find((spin: IFreeBetSpin) => spin.id === this.getFreeBetWin.data.id);
    },
    getBetCount(): number {
      if (!this.getFreeBet) return 0;
      return this.getFreeBet.reward.betCount;
    },
    getBet(): string {
      if (!this.getFreeBet) return '';
      return `(${Utils.centsToMoneyStr(
        this.getFreeBet.reward.bet,
        this.getFreeBet.info.currency.decimals,
        this.getFreeBetCurrencyCode
      )} ${this.getFormatedCurrency})`;
    },
    getFormatedCurrency(): string {
      return Utils.formatCurrencyCodeToMili(this.getFreeBetCurrencyCode);
    }
  },
  methods: {
    ...mapActions(['setTabIndexPopup']),
    closePopup(): void {
      promoApp.store.dispatch(ACTION.SET_MESSAGE_VISIBLE, { visible: false, type: 'winFreeBet' });
    },
    openFreeBetsPopup(): void {
      promoApp.eventEmitter.emit(ACTION.SET_TAB_WELCOME_VISIBLE, { visible: true });
      this.setTabIndexPopup({ position: 1 });
      this.closePopup();
    }
  }
});
</script>

<style lang="scss" scoped>
.win-freeBet__wrapper {
  background: rgb(255, 96, 0);
  background: linear-gradient(0deg, rgba(255, 96, 0, 1) 0%, rgba(194, 0, 32, 1) 100%);
  width: 100%;
  color: white;
  border-radius: 24px;
  border: 2px solid #01ff57;
  padding: 10px 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  font-size: 22px;
  line-height: 26px;
}

.win-freeBet__title {
  margin-right: 10px;
}

.win-freeBet__parameters {
  margin-right: 10px;
}

.win-freeBet__btn {
  display: inline-block;
  padding: 10px 20px;
  background-color: #15b200;
  border: 2px solid #01ff57;
  transition: all 0.3s ease;
  border-radius: 24px;
  cursor: pointer;
  margin-right: 10px;
}

.win-freeBet__btn:hover {
  background-color: #05d34d;
}

.win-freeBet__close {
  cursor: pointer;
  transition: all 0.1s ease;

  &:hover {
    .wrapper_btn_close:after {
      background-color: white;
    }

    .wrapper_btn_close:before {
      background-color: white;
    }
  }
}

.wrapper_btn_close {
  width: 32px;
  height: 32px;
  position: relative;
}

.wrapper_btn_close:after {
  content: '';
  display: block;
  width: 28px;
  height: 3px;
  background-color: #b4b4b4;
  position: absolute;
  top: 14px;
  left: 3px;
  transform: rotate(45deg);
  transition: all 0.3s ease;
}

.wrapper_btn_close:before {
  content: '';
  display: block;
  width: 28px;
  height: 3px;
  background-color: #b4b4b4;
  position: absolute;
  top: 14px;
  left: 3px;
  transform: rotate(-45deg);
  transition: all 0.3s ease;
}
</style>
